import { ArrowRight, WarningCircle, X } from "@phosphor-icons/react";
import React, { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import { toast, Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import "../../Styles/CreateBooking.css";
import PageLoader from '../loader/PageLoader';
import { toHotelISO } from "../../api/hotelTime";
import { applyStayTime, useStayTimes } from "../../api/useStayTimes";

const CreateBooking = ({ func }) => {

    const getTodayWithTime = (hour, minute) => {
        const now = new Date();
        now.setHours(hour, minute, 0, 0);

        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const day = String(now.getDate()).padStart(2, "0");
        const hours = String(now.getHours()).padStart(2, "0");
        const minutes = String(now.getMinutes()).padStart(2, "0");

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };



    const [formData, setFormData] = useState({
        ota_id: "",
        contact: null,
        name: "",
        guest_email: "",
        rooms: "",
        checkin_date: getTodayWithTime(12, 0), // 12:00 PM
        checkout_date: getTodayWithTime(10, 0), // 10:00 AM
        number_of_people: "",
    });

    console.log("Form Data : ",formData)

    const [errors, setErrors] = useState({});
    const stayTimes = useStayTimes();
    const hotelId = localStorage.getItem("hotelId");
    const [countryCode, setCountryCode] = useState("91");
    const [isLoading,setIsLoading] = useState(false);

    const navigate = useNavigate();

    const validateForm = () => {
        const newErrors = {};
        if (!formData.ota_id) newErrors.ota_id = "Id is required!";
        if (!formData.contact) newErrors.contact = "Contact is required";
        if (!formData.name) newErrors.name = "Name is required";
        // if (!formData.guest_email) newErrors.guest_email = "Email is required";
        if (!formData.rooms) newErrors.rooms = "Number of rooms is required";
        if (!formData.number_of_people)
            newErrors.number_of_people = "Guest Count is required";
        if (!formData.checkin_date)
            newErrors.checkin_date = "Checkin date is required";
        if (!formData.checkout_date)
            newErrors.checkout_date = "CheckOut date is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // The hotel's configured stay hours arrive after first paint, so the seeded
    // placeholder times are corrected once they land. This only seeds the form —
    // once staff edit a field, what they type is what gets saved.
    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            checkin_date: applyStayTime(
                prev.checkin_date,
                stayTimes.checkin_time,
            ),
            checkout_date: applyStayTime(
                prev.checkout_date,
                stayTimes.checkout_time,
            ),
        }));
    }, [stayTimes.checkin_time, stayTimes.checkout_time]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "contact" && (!/^\d*$/.test(value) || value.length > 10))
            return;
        if (name === "rooms" && !/^\d*$/.test(value)) return;
        setFormData((prev) => ({ ...prev, [name]: value }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "",
        }));
    };


    // Extend Day.js with the utc plugin
    dayjs.extend(utc);
    const handleSubmit = async (e) => {

        try{
            setIsLoading(true);
            // console.log("--------", formData.checkin_date);
            e.preventDefault();
            if (!validateForm()) return;
    
            // Use numeric UTC offset (in minutes)
            const checkinDate = toHotelISO(formData.checkin_date);
            const checkoutDate = toHotelISO(formData.checkout_date);
                
                const updated_contact = countryCode + formData.contact;
            const finalForm = {
                ...formData,
                contact: parseInt(updated_contact),
                rooms: parseInt(formData.rooms),
                number_of_people: parseInt(formData.number_of_people),
                checkin_date: checkinDate,
                checkout_date: checkoutDate,
            };
    
            // console.log("--------", finalForm);
            // return;
    
            try {
                const response = await axiosInstance.post(
                    `/api/v1/hotels/${hotelId}/bookings`,
                    finalForm,
                );
                // console.log(response.data);
                toast.success("Booking created successfully.");
                setTimeout(() => {
                    func(false);
                    navigate("/dashboard/bookings");
                }, 100);
            } catch (error) {
                toast.error(error?.response?.data?.message || "Some Error Occured");
                console.error("Error occured in creatingbooking", error);
            }
            // console.log(finalForm);

        }catch(error){
            console.log(error)
        }
        finally{
            setIsLoading(false);
        }

    };

    return (
        <>
            {
                isLoading && <PageLoader/>
            }
            <div className="fixed top-0 left-0 h-screen w-screen bg-black bg-opacity-60 flex items-center justify-center z-[45]">
                <form
                    style={{height: "600px" }}
                    className="createBooking popup-content bg-white  p-6 rounded-lg text-sm flex flex-col gap-2 overflow-y-auto"
                    onSubmit={handleSubmit}
                >
                    <div className="flex items-center justify-between">
                        <h2 className="text-xl font-semibold">New Booking</h2>
                        <button
                            onClick={() => func(false)}
                            className="bg-[#F2F7FF] p-1.5 border-[1.5px] rounded-md"
                        >
                            <X weight="bold" size={18} />
                        </button>
                    </div>
                    <div>
                        <p>Booking ID</p>
                        <input
                            type="text"
                            placeholder="Enter booking id"
                            className="w-full p-2 rounded-md border-[1.5px] mt-1"
                            name="ota_id"
                            value={formData.ota_id}
                            onChange={handleChange}
                        />
                        {errors.ota_id && (
                            <span className="text-[#E47186] text-xs flex items-center gap-1">
                                <WarningCircle className="text-sm" />
                                {errors.ota_id}
                            </span>
                        )}
                    </div>
                    <div>
                        <p>Name</p>
                        <input
                            type="text"
                            placeholder="Enter name of the guest"
                            className="w-full p-2 rounded-md border-[1.5px] mt-1 "
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                        />
                        {errors.name && (
                            <span className="text-[#E47186] text-xs flex items-center gap-1">
                                <WarningCircle className="text-sm" />
                                {errors.name}
                            </span>
                        )}
                    </div>
                    <div className="flex gap-2">
                        <div>
                            <label htmlFor="">No. Of Rooms</label>
                            <input
                                type="text"
                                placeholder="enter the number of rooms booked"
                                className="w-full rounded-md border-[1.5px] p-2 mt-1"
                                name="rooms"
                                value={formData.rooms}
                                onChange={handleChange}
                            />
                            {errors.rooms && (
                                <span className="text-[#E47186] text-xs flex items-center gap-1">
                                    <WarningCircle className="text-sm" />
                                    {errors.rooms}
                                </span>
                            )}
                        </div>
                        <div>
                            <label htmlFor="">No. Of Guest</label>
                            <input
                                type="text"
                                placeholder="enter the number of guests"
                                className="w-full rounded-md border-[1.5px] p-2 mt-1"
                                name="number_of_people"
                                value={formData.number_of_people}
                                onChange={handleChange}
                            />
                            {errors.number_of_people && (
                                <span className="text-[#E47186] text-xs flex items-center gap-1">
                                    <WarningCircle className="text-sm" />
                                    {errors.number_of_people}
                                </span>
                            )}
                        </div>
                    </div>
                    <div>
                        <label htmlFor="">Email ID</label>
                        <input
                            type="email"
                            className="w-full p-2 rounded-md border-[1.5px] mt-1"
                            placeholder="Enter your booking email"
                            name="guest_email"
                            value={formData.guest_email}
                            onChange={handleChange}
                        />
                        {errors.guest_email && (
                            <span className="text-[#E47186] text-xs flex items-center gap-1">
                                <WarningCircle className="text-sm" />
                                {errors.guest_email}
                            </span>
                        )}
                    </div>
                    <div>
                        <label htmlFor="">Contact</label>
                        <div className="flex items-center border-[1.5px] rounded-md gap-2 overflow-hidden mt-1">
                            <select
                                name="country_code"
                                value={countryCode}
                                onChange={(e) => setCountryCode(e.target.value)}
                                className="border-r-[1.5px] p-2 outline-none"
                            >
                                <option value="91">+91</option>
                                <option value="88">+88</option>
                            </select>
                            <input
                                type="text"
                                placeholder="Enter the contact for booking"
                                className="w-full p-2 outline-none"
                                value={formData.contact}
                                name="contact"
                                onChange={handleChange}
                            />
                        </div>

                        {errors.contact && (
                            <span className="text-[#E47186] text-xs flex items-center gap-1">
                                <WarningCircle className="text-sm" />
                                {errors.contact}
                            </span>
                        )}
                    </div>
                    <div className="flex gap-2">
                        <div className="w-1/2">
                            <label htmlFor="">Check-in Date</label>
                            <div className="w-full rounded-md border-[1.5px] flex items-center px-2">
                                <span className="text-gray-500">From</span>
                                <input
                                    type="datetime-local"
                                    className="w-full p-2 rounded-md"
                                    name="checkin_date"
                                    value={formData.checkin_date}
                                    onChange={handleChange}
                                />
                            </div>
                            {errors.checkin_date && (
                                <span className="text-[#E47186] text-xs flex items-center gap-1">
                                    <WarningCircle className="text-sm" />
                                    {errors.checkin_date}
                                </span>
                            )}
                        </div>
                        <div className="w-1/2">
                            <label htmlFor="">Check-out Date</label>
                            <div className="w-full rounded-md border-[1.5px] flex items-center px-2">
                                <span className="text-gray-500">To</span>
                                <input
                                    type="datetime-local"
                                    className="w-full p-2 rounded-md"
                                    value={formData.checkout_date}
                                    name="checkout_date"
                                    onChange={handleChange}
                                />
                            </div>
                            {errors.checkout_date && (
                                <span className="text-[#E47186] text-xs flex items-center gap-1">
                                    <WarningCircle className="text-sm" />
                                    {errors.checkout_date}
                                </span>
                            )}
                        </div>
                    </div>

                    <button className="flex items-center gap-2 bg-[#ff7378] p-2 rounded-md w-full justify-center mt-auto">
                        Save Booking <ArrowRight size={18} />
                    </button>
                </form>
                <Toaster
                    position="bottom-right"
                    reverseOrder={false}
                    transition="Bounce"
                    style={{ marginBottom: "25%" }}
                />
            </div>
        </>
    );
};

export default CreateBooking;
